var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopiar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,5.475V16.167a4.1,4.1,0,0,0,3.737,4.158l.263.009h7.063A2.41,2.41,0,0,1,13.4,22H7.8A4.9,4.9,0,0,1,3,17V7.833A2.5,2.5,0,0,1,4.6,5.475ZM16.6,2A2.452,2.452,0,0,1,19,4.5V16.167a2.452,2.452,0,0,1-2.4,2.5h-8a2.452,2.452,0,0,1-2.4-2.5V4.5A2.452,2.452,0,0,1,8.6,2Zm0,1.667h-8a.817.817,0,0,0-.8.833V16.167A.817.817,0,0,0,8.6,17h8a.817.817,0,0,0,.8-.833V4.5A.817.817,0,0,0,16.6,3.667Z",
    transform: "translate(1 -0.047)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiar);
export default __webpack_public_path__ + "static/media/copiar.55fcf50b24de7f09f56bce011752f8be.svg";
export { ForwardRef as ReactComponent };